// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export { defaultAuthStrategy } from './defaultAuthStrategy';
export { multiAuthStrategy } from './multiAuthStrategy';
//# sourceMappingURL=index.js.map